import script from "./SidebarBalanceContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarBalanceContainer.vue?vue&type=script&setup=true&lang=js"

import "./SidebarBalanceContainer.vue?vue&type=style&index=0&id=3bc6e034&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc6e034"]])

export default __exports__